export const accountURLs = {
  fetchAccount: (accountID: 'all' | number) => `/v1/accounts/${accountID}/without-balance`,
  fetchAccounts: () => '/v1/accounts/without-balance',
  openTrader: (userID: number) => `/v1/accounts/users/${userID}`,
  fetchCertificate: (userID: number, accountID: number) => `/v1/accounts/users/${userID}/${accountID}/certificate`,
  restoreAccount: (userID: number, accountID: number) => `/v1/accounts/users/${userID}/${accountID}/restore`,
  restoreTPAccount: (accountID: number) => `/2/v1/tp/user-service/unarchive/${accountID}`,
  changeName: (userID: number, accountID: number) => `/v1/accounts/users/${userID}/${accountID}/name`,
  changeComment: (userID: number, accountID: number) => `/v1/accounts/users/${userID}/${accountID}/comment`,
  setPrimaryAccount: (userID: number) => `/v1/accounts/users/${userID}/primary`,
  fetchMetrics: (userId: number) => `/v1/accounts/users/${userId}/balance`,
  leverageSettings: (accountId: number) => `/v1/leverage/${accountId}`,
  swapfreeSettings: (userId: number, accountId: number) => `/v2/users/${userId}/accounts/${accountId}/swapfree`,
  changeMetaTraderPswd: (userId: number, accountId: number) => `/v1/accounts/users/${userId}/${accountId}/password`,
  addDemoFunds: (userId: number, accountId: number) => `/v2/accounts/users/${userId}/${accountId}/demo-deposit`,
  openPartner: () => `/v1/ibp/partner`,
  getPartnerState: (accountId: number) => `/v1/ibp/account/${accountId}/status`,
  getMockPartnerState: (accountId: number) => `/assets/mocks/partner/account-partner-state.json`,
  attachPartner: () => `/v1/ibp/referral`,
  validatePartnerAttach: () => `/v1/ibp/attaching-error`,
};
